"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorLog = void 0;
var tslib_1 = require("tslib");
var enableRaygun_1 = require("./enableRaygun");
var logError_1 = require("./logError");
var setRaygunUser_1 = require("./setRaygunUser");
/**
 * Configures error logging and sends errors with Raygun
 * @deprecated use the exported functions instead - enableRaygun, setRaygunUser, logError
 */
var ErrorLog = /** @class */ (function () {
    function ErrorLog() {
    }
    /**
     * Enables error logging.
     * @param apiKey Raygun api key
     * @param version the application version
     */
    ErrorLog.prototype.enable = function (apiKey, version) {
        (0, enableRaygun_1.enableRaygun)(apiKey, version);
    };
    /**
     * Sets the user information so that it's included in the error log messages.
     * @param userDetails the logged in user info
     */
    ErrorLog.prototype.setUser = function (userDetails) {
        (0, setRaygunUser_1.setRaygunUser)(userDetails);
    };
    /**
     * Sends an error to Raygun
     * @param error the error
     * @param vm the Vue component
     * @param info info from the Vue error handler
     */
    ErrorLog.prototype.send = function (error, vm, info) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                (0, logError_1.logError)(error, vm, info);
                return [2 /*return*/];
            });
        });
    };
    return ErrorLog;
}());
exports.ErrorLog = ErrorLog;
//# sourceMappingURL=ErrorLog.js.map